<template>
	<div
		class="panel"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			class="container"
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div v-if="isHeaderVisible" class="panel_header">
				<h2>{{ block.block_title }}</h2>
				<div v-if="block.description" v-html="block.description" class="description"></div>
			</div>
			<div class="items-container">
				<div v-swiper:reviewSwiper="options">
					<div class="swiper-wrapper">
						<div
							class="swiper-slide col-12"
							:class="[
								block.columns ? 'col-lg-' + 12/block.columns : 'col-lg-4'
							]"
							v-if="block.items"
							v-for="(item, index) in block.items"
							v-bind:key="index"
						>
							<div class="item">
								<div class="subtitle" v-if="item.description" v-html="item.description"></div>
								<div class="author" v-if="item.person">
									<img v-if="item.person.square_photo" :src="item.person.square_photo" :alt="item.person.slug" />
									<div class="name" v-if="item.person.title">{{ item.person.title }}</div>
									<div class="description" v-if="item.person.job_title">{{ item.person.job_title }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="panel_footer">
				<div class="row justify-content-end">
					<div class="col-4 col-lg-2">
						<div class="swiper-navigation">
							<div
								:id="prevElId"
								class="btn btn-outline-primary icon-arrow_prev"
							/>
							<div
								:id="nextElId"
								class="btn btn-outline-primary icon-arrow_next"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import panel from "~/mixins/panel";

export default {
	name: "DraftReview1",
	mixins: [panel],

	components: {
		Swiper,
		SwiperSlide,
	},
	directives: {
		swiper: directive,
	},

	data() {
		return {
			options: {
				slidesPerView: 'auto',
				// spaceBetween: 40,
				// cssMode: false,
				// freeMode: true,
				loop: false,

				navigation: {
					nextEl: `#swiper-review-next_${this.block.id}`,
					prevEl: `#swiper-review-prev_${this.block.id}`,
					disabledClass: "disabled",
				},
			},
		};
	},

	computed: {
		prevElId() {
			return this.options.navigation.prevEl.slice(1);
		},
		nextElId() {
			return this.options.navigation.nextEl.slice(1);
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/draft-review-1";
</style>
